<div class="flex flex-col bg-transparent w-full">
  <div
    class="flex-1 upload-area border-2 border-dashed rounded-lg p-6 text-center bg-uploadBg hover:bg-slate-200 cursor-pointer transition-colors duration-200"
    [class.border-blue-500]="isDragging" [class.bg-blue-50]="isDragging" (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave()" (drop)="onDrop($event)" (click)="triggerFileSelect(fileInput)">
    <input id="file-input-{{card}}" type="file" #fileInput class="hidden" (change)="onFileSelected($event)"
      [multiple]="isMultiFileCard" accept=".pdf,application/pdf" />
    <div class="w-12 h-12 rounded-full bg-gray-200 flex items-center justify-center mx-auto mb-2">
      <mat-icon [svgIcon]="card === 'Devis' || card === 'Devis non signé' ? 'heroicons_outline:document-text' : 'heroicons_outline:folder-open'"
        class="h-10 w-10 text-accent">
      </mat-icon>
    </div>

    <p class="text-sm font-bold text-gray-800 text-center mb-2">
      {{ card }}
    </p>

    <p class="text-center text-xs text-gray-600 leading-relaxed">
      Glissez-déposez les fichiers ici ou <br>
      <span class="text-[#419a8c] font-semibold underline">cliquez pour parcourir</span>
    </p>

    <p class="text-[10px] text-gray-400 mt-3 italic">
      La taille maximale d'un fichier est de 25 Mo
    </p>
  </div>

  <div *ngIf="errorMessages.length > 0" class="mt-2">
    <div *ngFor="let msg of errorMessages" class="text-red-500 text-xs font-medium">
      {{ msg }}
    </div>
  </div>
</div>